module.exports = __webpack_public_path__ + "img/students1.feac516d.png";